const baseUrl = "https://api.truidconnect.com/consumer-api";

export default {
  API_URL_REASONS: `${baseUrl}/reasons`,
  API_KEY: "5e4729b6d3bc48dcaaca943dfe57671b",
  API_URL_COLLECTION: `${baseUrl}/collections`,
  API_URL_CONSENTS: `${baseUrl}/consents`,
  API_URL_BANKS: `${baseUrl}/banks`,

  APP_STATE: {
    LOADED: "LOADED",
    LOADING: "LOADING",
    FAILED: "FAILED",
    NULL: "NULL",
  },
};
